<template>
  <StepRegistrationLocation
    :country-code="userContact.countryCode"
    :zip-code="userContact.zipCode"
    @nextStep="handleSubmit"
    @prevStep="$emit('prevStep')"
    @attributeChange="handleAttributeChange"
  />
</template>

<script>
import axios from 'axios'
import mapKeys from 'lodash/mapKeys'
import snakeCase from 'lodash/snakeCase'
import camelCase from 'lodash/camelCase'
import pick from 'lodash/pick'
import transform from 'lodash/transform'
import some from 'lodash/some'
import { csrfToken } from '@/utils/csrf'

import StepRegistrationLocation from './StepRegistrationLocation.vue'

export default {
  name: 'StepContactUpdate',
  components: {
    StepRegistrationLocation
  },
  data() {
    return {
      loading: false,
      userContact: {
        countryCode: '',
        zipCode: ''
      },
      errors: {}
    }
  },
  computed: {
    params() {
      const params = pick(this.userContact, ['zipCode', 'countryCode'])

      return mapKeys(params, (v, k) => snakeCase(k))
    },
    submitDisabled() {
      return this.loading || some(this.userContact, (v, k) => v.length < 1)
    }
  },
  methods: {
    handlePrevStep() {
      this.$emit('prevStep')
    },
    handleAttributeChange(param, value) {
      this.userContact[param] = value
    },
    parseErrors(data) {
      return transform(
        data,
        (res, v, k) => {
          const key = camelCase(k.replace('user_contact.', ''))
          res[key] = v
        },
        {}
      )
    },
    handleSubmit() {
      if (this.loading) {
        return false
      }

      const token = csrfToken()
      this.errors = {}
      this.loading = true

      axios
        .put(
          '/api/current/user_contacts',
          { user_contact: this.params },
          { headers: { 'X-CSRF-Token': token, Accept: 'application/json' } }
        )
        .then(response => {
          this.$emit('nextStep')
          this.loading = false
        })
        .catch(error => {
          const data = error.response.data
          this.errors = data.error ? { base: data.error } : this.parseErrors(data.errors)
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
form {
  padding: 0;
}

@media (min-width: 768px) {
  form {
    padding: 0 48px;
  }
}

.error {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.step-navigation-right {
  margin-left: auto;

  .btn-link {
    color: #999;
    margin-right: 12px;

    &:focus,
    &:hover {
      color: #666;
    }
  }
}
</style>
